"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _ediFeedBack = require("@/api/bookSpace/ediFeedBack");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default
  },
  props: {
    newHotTableSelections: {
      type: Array,
      default: null
    }
  },
  data: function data() {
    return {
      code: [{
        codeValue: 4218
      }, {
        codeValue: 4258
      }],
      rules: {
        code: [{
          required: true,
          message: this.$t('userCenter.ediFeedBack.validCustomsCode'),
          trigger: ['blur', 'change']
        }],
        changeContactName: [{
          required: true,
          message: this.$t('userCenter.ediFeedBack.validChangeApplicantName'),
          trigger: 'blur'
        }],
        changeContactTel: [{
          required: true,
          message: this.$t('userCenter.ediFeedBack.validChangeApplicantTel'),
          trigger: 'blur'
        }],
        changeReason: [{
          required: true,
          message: this.$t('userCenter.ediFeedBack.validChangeReason'),
          trigger: 'blur'
        }]
      },
      form: {
        newSelections: null,
        code: '',
        changeContactName: '',
        changeContactTel: '',
        changeReason: ''
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    opened: function opened() {
      var newSelections = this.newHotTableSelections.reduce(function (x, y) {
        (x[y.newVoyageNoLeg] = x[y.newVoyageNoLeg] || []).push(y);
        return x;
      }, {});
      for (var key in newSelections) {
        newSelections[key] = newSelections[key].map(function (item) {
          return item.blNo;
        });
      }
      this.form.newSelections = newSelections;
    },
    handleClose: function handleClose() {
      this.$parent.cnTaoDeleteMsgDialogVisible = false;
    },
    handleClear: function handleClear() {
      this.form = {
        blList: [],
        code: '',
        changeContactName: '',
        changeContactTel: '',
        changeReason: ''
      };
    },
    closed: function closed() {
      this.handleClear();
      this.$parent.handleSearch();
    },
    handleReset: function handleReset() {
      this.form = {
        blList: [],
        code: '',
        changeContactName: '',
        changeContactTel: '',
        changeReason: ''
      };
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.loading = (0, _utils.load)();
          var data = JSON.parse(JSON.stringify({
            mapArg: {
              customId: _this.form.code,
              strChangeReson: _this.form.changeReason,
              strChangeContactName: _this.form.changeContactName,
              strChangeContactTel: _this.form.changeContactTel
            },
            mapBl: _this.form.newSelections
          }));
          (0, _ediFeedBack.sendToFtp)(data).then(function (res) {
            if (res.data) {
              if (res.data === true) {
                _this.$message.success(_this.$t('userCenter.ediFeedBack.deleteSuccess'));
                _this.$parent.handleSearch();
                _this.$parent.cnTaoDeleteMsgDialogVisible = false;
              } else {
                _this.$message.warning(_this.$t('userCenter.ediFeedBack.delFail'));
              }
            } else {
              _this.$message.warning(res.errorMessages[0]);
            }
          }).finally(function () {
            _this.loading.close();
          });
        }
      });
    }
  }
};